import { FunctionComponent, ImgHTMLAttributes } from 'react'
import { colors } from 'shared/styles/colors'

type TImgProps = ImgHTMLAttributes<HTMLImageElement> & {
  loading?: boolean
  color?: string
  size?: number
}

const IconVeiculo: FunctionComponent<TImgProps> = ({
  color = colors.primary,
  size = 16,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M26.2104 5.03284L23.4795 7.76377C25.1429 9.71102 26.1473 12.2382 26.1473 14.9999C26.1473 17.7614 25.1429 20.2884 23.4795 22.2355L26.2107 24.9667C28.5682 22.317 30.0006 18.8257 30.0006 14.9999C30.0006 11.174 28.5682 7.68268 26.2104 5.03284Z"
          fill={color}
        />
        <path
          d="M15.0001 3.8533C17.7618 3.8533 20.2888 4.8576 22.236 6.5209L24.9669 3.78996C22.3171 1.43232 18.8259 0 15.0001 0C11.1743 0 7.68299 1.43232 5.0332 3.7899L7.76414 6.52084C9.71139 4.8576 12.2384 3.8533 15.0001 3.8533Z"
          fill={color}
        />
        <path
          d="M15.0003 26.1461C12.2387 26.1461 9.71162 25.1418 7.76443 23.4786L5.0332 26.2099C7.68305 28.5676 11.1744 30 15.0003 30C18.8262 30 22.3176 28.5676 24.9674 26.2098L22.2362 23.4785C20.289 25.1418 17.7619 26.1461 15.0003 26.1461Z"
          fill={color}
        />
        <path
          d="M3.8533 14.9999C3.8533 12.2381 4.85766 9.71096 6.52107 7.76377L3.79019 5.03284C1.43238 7.68262 0 11.174 0 14.9999C0 18.8257 1.43232 22.317 3.78996 24.9668L6.52113 22.2356C4.85771 20.2885 3.8533 17.7614 3.8533 14.9999Z"
          fill={color}
        />
        <path
          d="M15 16.1334C15.4854 16.1334 15.8789 15.7399 15.8789 15.2545C15.8789 14.7691 15.4854 14.3756 15 14.3756C14.5146 14.3756 14.1211 14.7691 14.1211 15.2545C14.1211 15.7399 14.5146 16.1334 15 16.1334Z"
          fill={color}
        />
        <path
          d="M6.66777 10.6764C5.99277 11.9714 5.61133 13.4421 5.61133 15.0001C5.61133 15.7389 5.69687 16.4585 5.85918 17.1487C8.86094 17.819 11.1262 20.4387 11.2574 23.6098C12.4047 24.1108 13.6709 24.3885 15.0004 24.3885C16.3299 24.3885 17.5961 24.1108 18.7434 23.6098C18.8746 20.4387 21.1398 17.819 24.1416 17.1487C24.3039 16.4585 24.3894 15.7389 24.3894 15.0001C24.3894 13.4421 24.008 11.9714 23.333 10.6764C20.6658 10.0091 17.8744 9.65515 15.0004 9.65515C12.1264 9.65515 9.33496 10.0091 6.66777 10.6764ZM10.518 15.1096H8.76016V13.3518H10.518V15.1096ZM19.4828 13.3518H21.2406V15.1096H19.4828V13.3518ZM15.8793 21.7178H14.1215V19.96H15.8793V21.7178ZM17.6371 15.2544C17.6371 16.7087 16.4541 17.8911 15.0004 17.8911C13.5467 17.8911 12.3637 16.7087 12.3637 15.2544C12.3637 13.8007 13.5467 12.6177 15.0004 12.6177C16.4541 12.6177 17.6371 13.8007 17.6371 15.2544Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="30" height="30" fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}
export default IconVeiculo
